import api from "../../infra/api";

class SolicitacaoFiscalizacao {
  async Listar(codigoResp, filtro) {
    const response = await api({
      method: "GET",
      url: filtro.trim() === ""
        ? `/api/v1/SolicitacaoFiscalizacao?page=1&start=0&limit=999&fields=["Id", "NumeroFiscalizacao", "SituacaoFiscalizacao", "NumeroAnalise", "CodigoSolicCompart", "CodigoResponsavelTecnico", "CodigoOcupante", "Protocolo", "CodigoTipoVistoria", "CodigoUsuario", "Usuario", "DataCadastro", "DataApresentacao", "PrazoAnalise", "DataInicioInstalacao", "DataTerminoInstalacao", "DataConclusao", "GeraServico", "ParecerAnalise", "ParecerVistoria", "SolicitacaoCompartilhamento.CodigoVisual"]&includes=["SolicitacaoCompartilhamento","ResponsavelTecnico","Ocupante"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":false}]`
        : `/api/v1/SolicitacaoFiscalizacao?page=1&start=0&limit=999&fields=["Id", "NumeroFiscalizacao", "SituacaoFiscalizacao", "NumeroAnalise", "CodigoSolicCompart", "CodigoResponsavelTecnico", "CodigoOcupante", "Protocolo", "CodigoTipoVistoria", "CodigoUsuario", "Usuario", "DataCadastro", "DataApresentacao", "PrazoAnalise", "DataInicioInstalacao", "DataTerminoInstalacao", "DataConclusao", "GeraServico", "ParecerAnalise", "ParecerVistoria", "SolicitacaoCompartilhamento.CodigoVisual"]&includes=["SolicitacaoCompartilhamento","ResponsavelTecnico","Ocupante"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true}]`
    });

    return response.data;
  }

  async ListarCFiltros(codigoResp, pesquisaGeral) {
    let url = `/api/v1/SolicitacaoFiscalizacao?page=1&start=0&limit=999&includes=["SolicitacaoCompartilhamento"]&fields=["Id", "NumeroFiscalizacao", "SituacaoFiscalizacao", "NumeroAnalise", "CodigoSolicCompart", "CodigoResponsavelTecnico", "CodigoOcupante", "Protocolo", "CodigoTipoVistoria", "CodigoUsuario", "Usuario", "DataCadastro", "DataApresentacao", "PrazoAnalise", "DataInicioInstalacao", "DataTerminoInstalacao", "DataConclusao", "GeraServico", "ParecerAnalise", "ParecerVistoria","SolicitacaoCompartilhamento","SolicitacaoCompartilhamento.CodigoVisual"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false}]`;

    if (pesquisaGeral.trim() !== "") {
      url = url.slice(0, -1);
      url += `,{"property":"Protocolo","operator":"equal","value":"${pesquisaGeral}"]`;
    }

    const response = await api({
      method: "GET",
      url: url
    });

    return response.data;
  }

  async listarCfeSituacaoOuDatas(codigoResp, pesquisaGeral, codigoSolicitacaoAcesso, situacao, tipoDataFiltro, dataInicial, dataFinal) {
    let filter = this.retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, codigoSolicitacaoAcesso, situacao, tipoDataFiltro, dataInicial, dataFinal);
    let url = filter.trim() === "" ?
      `/api/v1/SolicitacaoFiscalizacao?page=1&start=0&limit=999&includes=["SolicitacaoCompartilhamento"]&fields=["Id", "NumeroFiscalizacao", "SituacaoFiscalizacao", "NumeroAnalise", "CodigoSolicCompart", "CodigoResponsavelTecnico", "CodigoOcupante", "Protocolo", "CodigoTipoVistoria", "CodigoUsuario", "Usuario", "DataCadastro", "DataApresentacao", "PrazoAnalise", "DataInicioInstalacao", "DataTerminoInstalacao", "DataConclusao", "GeraServico", "ParecerAnalise", "ParecerVistoria","SolicitacaoCompartilhamento","SolicitacaoCompartilhamento.CodigoVisual"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false}]` :
      `/api/v1/SolicitacaoFiscalizacao?page=1&start=0&limit=999&includes=["SolicitacaoCompartilhamento"]&fields=["Id", "NumeroFiscalizacao", "SituacaoFiscalizacao", "NumeroAnalise", "CodigoSolicCompart", "CodigoResponsavelTecnico", "CodigoOcupante", "Protocolo", "CodigoTipoVistoria", "CodigoUsuario", "Usuario", "DataCadastro", "DataApresentacao", "PrazoAnalise", "DataInicioInstalacao", "DataTerminoInstalacao", "DataConclusao", "GeraServico", "ParecerAnalise", "ParecerVistoria","SolicitacaoCompartilhamento","SolicitacaoCompartilhamento.CodigoVisual"]&sort=[{"property":"Id","direction":"DESC"}]&filter=${filter}`

    const response = await api({
      method: "GET",
      url: url
    });

    return response.data;
  }

  retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, codigoSolicitacaoAcesso, situacao, tipoDataFiltro, dataInicial, dataFinal) {
    let temPesquisaGeral = pesquisaGeral.trim() !== "";

    if (temPesquisaGeral) {
      let filtroSituacaoDatas = this.handleFiltrosSituacaoOuDatas(codigoResp, codigoSolicitacaoAcesso, situacao, tipoDataFiltro, dataInicial, dataFinal);
      let filtroFinal = "," + filtroSituacaoDatas.slice(1);

      return `[{"property":"Id","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"Protocolo","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":${codigoResp},"and":true,"not":false}` + filtroFinal;
    } else {
      return this.handleFiltrosSituacaoOuDatas(codigoResp, codigoSolicitacaoAcesso, situacao, tipoDataFiltro, dataInicial, dataFinal);
    }
  }

  handleFiltrosSituacaoOuDatas(codigoResp, codigoSolicitacaoAcesso, situacao, tipoDataFiltro, dataInicial, dataFinal) {
    let temSituacaoInformada = situacao.length > 0;
    let temPeriodoInformado = (dataInicial && dataInicial.toLocaleDateString() !== "") && (dataFinal && dataFinal.toLocaleDateString() !== "");
    let arraySituacaoFormatada = JSON.stringify(situacao);
    let campoParaFiltrarData = "";

    switch (tipoDataFiltro) {
      case "data-cadastro":
        campoParaFiltrarData = "DataCadastro";
        break;
      case "data-apresentacao":
        campoParaFiltrarData = "DataApresentacao";
        break;
      case "data-prazo-analise":
        campoParaFiltrarData = "PrazoAnalise";
        break;
      case "data-inicio-instal":
        campoParaFiltrarData = "DataInicioInstalacao";
        break;
      case "data-termino-instal":
        campoParaFiltrarData = "DataTerminoInstalacao";
        break;
      case "data-conslusao":
        campoParaFiltrarData = "DataConclusao";
        break;
      default:
        campoParaFiltrarData = "DataCadastro";
        break;
    }

    if (temSituacaoInformada && !temPeriodoInformado) {
      return `[{"property":"CodigoSolicCompart","operator":"equal","value":"${codigoSolicitacaoAcesso}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"SituacaoFiscalizacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false}]`
    } else if (!temSituacaoInformada && temPeriodoInformado) {
      return `[{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial.toLocaleDateString()}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal.toLocaleDateString()}","and":true}]`
    } else {
      return `[{"property":"CodigoSolicCompart","operator":"equal","value":"${codigoSolicitacaoAcesso}","and":true,"not":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"SituacaoFiscalizacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial ? dataInicial.toLocaleDateString() : "01/01/1900"}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal ? dataFinal.toLocaleDateString() : "01/01/1900"}","and":true}]`
    }
  }

  async Inserir(dto) {
    const response = await api({
      method: "POST",
      url: "/api/v1/SolicitacaoFiscalizacao",
      data: JSON.stringify(dto)
    });

    return response.data;
  }

  async Editar(dto) {
    const response = await api({
      method: "PUT",
      url: `/api/v1/SolicitacaoFiscalizacao/${dto.Id}`,
      data: JSON.stringify(dto)
    });

    return response.data;
  }

  async RecuperarParaEditar(codigoSolicFiscalizacao) {
    const response = await api({
      method: "GET",
      url: `/api/v1/SolicitacaoFiscalizacao/${codigoSolicFiscalizacao}`,
    });

    return response.data;
  }

  async SolicitarAnalise(id) {
    const response = await api({
      method: "PUT",
      url: `api/v1/SolicitacaoFiscalizacao/SolicitarAnalise/${id}`
    });

    return response.data;
  }

  async Cancelar(codigoSolicFiscalizacao) {
    const response = await api({
      method: "PUT",
      url: `/api/v1/SolicitacaoFiscalizacao/Cancelar/${codigoSolicFiscalizacao}`
    });

    return response.data;
  }

  async ListarSolicitacoesFiscalizacaoAnalise(codigoSolicitacaoFiscalizacao, filtro) {
    const response = await api({
      method: "GET",
      url: filtro.trim() === ""
        ? `/api/v1/SFAnalise?page=1&start=0&limit=999&fields=["Id", "NumeroAnalise", "DataAnalise", "CodigoFiscalizacao", "NumeroFiscalizacao", "SituacaoFiscalizacao", "CodigoSolicCompart", "CodigoResponsavelTecnico", "CodigoOcupante", "Protocolo", "CodigoTipoVistoria", "CodigoUsuario", "Usuario", "DataCadastro", "DataApresentacao", "PrazoAnalise", "DataInicioInstalacao", "DataTerminoInstalacao", "DataConclusao", "GeraServico", "ParecerAnalise", "ParecerVistoria"]&filter=[{"property":"CodigoFiscalizacao","operator":"equal","value":"${codigoSolicitacaoFiscalizacao}","and":true}]&sort=[{"property":"Id","direction":"DESC"}]`
        : `/api/v1/SFAnalise?page=1&start=0&limit=999&fields=["Id", "NumeroAnalise", "DataAnalise", "CodigoFiscalizacao", "NumeroFiscalizacao", "SituacaoFiscalizacao", "CodigoSolicCompart", "CodigoResponsavelTecnico", "CodigoOcupante", "Protocolo", "CodigoTipoVistoria", "CodigoUsuario", "Usuario", "DataCadastro", "DataApresentacao", "PrazoAnalise", "DataInicioInstalacao", "DataTerminoInstalacao", "DataConclusao", "GeraServico", "ParecerAnalise", "ParecerVistoria"]&filter=[{"property":"CodigoFiscalizacao","operator":"equal","value":"${codigoSolicitacaoFiscalizacao}","and":true}, {"property":"DataApresentacao","operator":"greaterOrEqual","value":"${filtro}","and":true}]`
    });
    return response.data;
  }

  async SolicitacoesCompartilhamentoParaFiscalizar(codigoResp) {
    const response = await api({
      method: "GET",
      url: `/api/v1/SolicitacaoFiscalizacao/SolicitacoesCompartilhamentoParaFiscalizar/${codigoResp}`
    });
    return response.data;
  }
}

export default new SolicitacaoFiscalizacao;